<template>
  <GmbLayout>
    <header class="container-fluid z-index-1 px-0 gmb-l-header">
      <div class="d-flex mb-2 align-items-center gmb-navbar">
        <div class="d-flex py-2 px-3 flex-column gmb-l-header__left-column">
          <GmbRow>
            <GmbBrandLogo v-if="brandingInformation && brandingInformation.brand_integration != 'FULL_BRANDING'" />
          </GmbRow>
        </div>

        <div class="d-flex py-2 px-3 flex-column">
          <GmbObservatoryEntitySelector
              v-if="activatedEntity"
              :activatedEntity="activatedEntity"
              :entities="optimizedEntities"
              @activated-entity-changed="onActivatedEntityChanged"
          />
        </div>

        <div class="d-flex ml-auto py-2 px-3 flex-column">
          <GmbAccountMenu
              :userAccount="userAccount"
          />
        </div>
      </div>
    </header>

    <div class="d-flex z-index-0 flex-grow-1 h-0">
      <div :class="{'gmb-horizontally-collapsed': !isSidePanelOpen, 'd-flex flex-column': isSidePanelOpen}">
        <aside class="d-flex container-fluid flex-grow-1 px-0 h-0 flex-column">
          <div
              class="d-flex mt-2 mr-2 flex-grow-1 p-3 h-0 flex-column rounded-tr-1 bg-theme-1 gmb-block--side-panel"
          >
            <FdScroll y>
              <GmbSidePanel
                  :activatedEntity="activatedEntity"
                  :comparisonFilterCategory="comparisonFilterCategory"
                  :finalFilteredIndividualWorkforce="
                  finalFilteredIndividuals ? finalFilteredIndividuals.length : 0
                "
                  :importedIndividualWorkforce="importedIndividualWorkforce"
                  :individualFilterCategory="individualFilterCategory"
                  :organizationFilterCategory="organizationFilterCategory"
                  :organizations="allOrganizations"
                  :sourcedIndividualWorkforce="sourcedIndividualWorkforce"
                  :theoreticalIndividualWorkforce="theoreticalIndividualWorkforce"
                  :transportFilterCategory="transportFilterCategory"
                  :enableDescriptionDisplay="enableDescriptionDisplay && (activatedEntity.entityObj.description !== '')"

                  @organization-data-sources-activated-organizations-changed="
                  onOrganizationDataSourcesActivatedOrganizationsChanged
                "
                  @organization-data-sources-activated-address-changed="
                  onOrganizationDataSourcesActivatedAddressChanged
                "
                  @comparison-filter-activated-options-changed="
                  onComparisonFilterActivatedOptionsChanged
                "
                  @individual-filter-activated-options-changed="
                  onIndividualFilterActivatedOptionsChanged
                "
                  @organization-filter-activated-options-changed="
                  onOrganizationFilterActivatedOptionsChanged
                "
                  @transport-filter-activated-options-changed="
                  onTransportFilterActivatedOptionsChanged
                "
              />
            </FdScroll>
          </div>
        </aside>
      </div>

      <div class="d-flex flex-grow-1 flex-column">
        <main class="d-flex container-fluid flex-grow-1 px-0 h-0 flex-column">
          <div class="d-flex mt-2 ml-2 flex-grow-1 h-0 flex-column">

            <GmbTabs ref="tabs" @activated-tab-changed="onActivatedTabChanged" style="position: relative;"
                     :brandingInformation="brandingInformation" :activatedEntity="activatedEntity">

              <template #tabList>

                <pacman-loader :loading="Boolean(spinnerEnabledCounter)" color="#3990d8" size="30px"></pacman-loader>

                <GmbTab headerTitleText="Carte" isFirstTab isWideBodyContent>
                  <template #tabHeaderNavItemPicto>
                    <FdText fa>
                      <i class="fas fa-lg fa-street-view"/>
                    </FdText>
                  </template>

                  <template #tabBody>
                    <GmbMap
                        :individuals="finalFilteredIndividuals"
                        :mapColorizerCategories="mapColorizerCategories"
                        :mapConfiguration="mapConfiguration"
                        :organizations="activatedOrganizations"
                        ref="gmbMap"
                        :transportFilters="
                        transportFiltersForIndividualMapPointInfo
                      "
                        :userAccount="userAccount"
                        :userCanAccessPdfExporter="userCanAccessPdfExporter"
                        @go-to-individuals-edit-page="goToIndividualsEditPage"
                        @switch-side-panel-visibility="onSwitchSidePanelVisibility"
                        @export-reporting-section="onExportMapToReporting"
                    />
                  </template>
                </GmbTab>

                <GmbTab
                    v-if="userCanAccessStatistics"
                    headerTitleText="Statistiques"
                    :lazy="true"
                >
                  <template #tabHeaderNavItemPicto>
                    <FdText fa>
                      <i class="fas fa-lg fa-chart-pie"/>
                    </FdText>
                  </template>

                  <template #tabBody>
                    <GmbStatistics
                        :mapColorizerCategories="mapColorizerCategories"
                        :importedIndividualWorkforce="importedIndividualWorkforce"
                        :individuals="finalFilteredIndividuals"
                        :miscEnumerations="miscEnumerations"
                        :organizations="activatedOrganizations"
                        :theoreticalIndividualWorkforce="
                        theoreticalIndividualWorkforce
                      "
                        :userCanAccessPdfExporter="userCanAccessPdfExporter"
                        @export-reporting-section="onExportStatisticsToReporting"
                    />
                  </template>
                </GmbTab>

                <!-- <GmbTab headerTitleText="Individual Mobility">
                    <template #tabHeaderNavItemPicto>
                      <FdText fa><i class="fas fa-lg fa-bicycle"
                    /></FdText></template>

                    <template #tabBody>
                      <GmbMobility />
                    </template>
                  </GmbTab> -->

                <GmbTab
                    v-if="userCanAccessDataEdition"
                    :headerTitleText="'Édition\xa0de\xa0données'"
                    :lazy="true"
                >
                  <template #tabHeaderNavItemPicto>
                    <FdText fa>
                      <i class="fas fa-lg fa-user-edit"/>
                    </FdText>
                  </template>

                  <template #tabBody>
                    <GmbDataEdition
                        :filterTree="individualFilterCategory"
                        :currentClientPk="currentClientPk"
                        :currentProjectPk="currentProjectPk"
                        :individuals="finalFilteredIndividuals"
                        :userAccount="userAccount"
                        ref="DataEdition"
                        @individuals-edited="onIndividualsEdited"
                    />
                  </template>
                </GmbTab>

                <GmbTab
                    v-if="userCanAccessPdfExporter"
                    :headerTitleText="'Rapport\xa0Pdf'"
                    :lazy="false"
                >
                  <template #tabHeaderNavItemPicto>
                    <FdText fa>
                      <i class="fas fa-lg fa-file-export"/>
                    </FdText>
                  </template>

                  <template #tabBody>
                    <GmbReporting
                        ref="Reporting"
                        :currentProjectPk="currentProjectPk"
                        :currentOrganizationPk="currentOrganizationPk"
                    />
                  </template>
                </GmbTab>

              </template>
            </GmbTabs>
          </div>
        </main>
      </div>
    </div>

    <template #modal>
      <GmbModal
          slug="entity-description-display"
          title="Description"
          :small-modal-format="true"
      >
        <div v-if="activatedEntity" v-html="activatedEntity.entityObj.description"></div>
      </GmbModal>

      <GmbModal
          slug="observatory-credential-manager"
          title="Comptes rattachés"
      >
        <GmbObservatoryEntityCredentialManager :entities="allEntities"/>
      </GmbModal>

      <GmbModal
          noCloseButton
          slug="create-individual"
          title="Créer un Individu"
      >
        <GmbDataEditionCreate
            :filterTree="individualFilterCategory"
            :miscEnumerations="miscEnumerations"
            :organizations="activatedOrganizations"
            @individuals-edited="onIndividualsEdited"
        />
      </GmbModal>
    </template>
  </GmbLayout>
</template>

<script>
import router from "../../router";
import {
  activateEntityFromList,
  findObjectInArrayByPropertyValue,
  findObjectIndexInArrayByPropertyValue,
} from "@/helpers.js";
import _, {random} from "lodash";
import * as authentication from "@/services/authentication";
import {getApiEndpoint} from "@/services/base";

/* There is already a spinner in BootstrapVue but this one is more sophisticated */
import PacmanLoader from 'vue-spinner/src/PacmanLoader.vue';

import FdScroll from "@/flexdesign/Scroll";
import FdText from "@/flexdesign/Text";

import GmbBrandLogo from "@/widgets/BrandLogo";
import GmbLayout from "@/widgets/Layout";
import GmbModal from "@/widgets/Modal";
import GmbRow from "@/widgets/Row";
import GmbTab from "@/widgets/Tab";
import GmbTabs from "@/widgets/Tabs";

import GmbAccountMenu from "@/views/Observatory/AccountMenu";
import GmbDataEdition from "@/views/Observatory/DataEdition/DataEdition";
import GmbDataEditionCreate from "@/views/Observatory/DataEdition/DataEditionCreate";
import GmbMap from "@/views/Observatory/Map/Map";
import GmbObservatoryEntityCredentialManager from "@/views/Observatory/ObservatoryEntityCredentialManager";
import GmbObservatoryEntitySelector from "@/views/Observatory/ObservatoryEntitySelector";
import GmbSidePanel from "@/views/Observatory/SidePanel/SidePanel";
import GmbStatistics from "@/views/Observatory/Statistics/Statistics";
import GmbReporting from "@/views/Observatory/Reporting/Reporting";
import {formatFrenchAddress} from "../../helpers";

var lastActivatedEntityIdentifierStorageKey =
    "lastActivatedObservatoryEntityIdentifier";

export default {
  name: "GmbObservatory",

  components: {
    PacmanLoader,

    FdScroll,
    FdText,

    GmbLayout,
    GmbModal,
    GmbBrandLogo,
    GmbRow,
    GmbTab,
    GmbTabs,

    GmbAccountMenu,
    GmbDataEdition,
    GmbDataEditionCreate,
    GmbMap,
    GmbObservatoryEntityCredentialManager,
    GmbObservatoryEntitySelector,
    GmbSidePanel,
    GmbStatistics,
    GmbReporting,
  },

  props: {
    activatedEntityIdentifierFromUrl: {
      type: String,
      default: null,
    }
  },

  data() {
    return {
      isSidePanelOpen: true,
      spinnerEnabledCounter: 0,
      activatedEntityIdentifier:
          this.activatedEntityIdentifierFromUrl ||
          localStorage.getItem(lastActivatedEntityIdentifierStorageKey) ||
          undefined, // Unique ID internalized to each entity
      allEntities: undefined,
      allIndividuals: undefined,
      allOrganizations: undefined,
      comparisonFilterCategory: undefined,
      individualFilterCategory: undefined,
      isAuthenticated: false,
      mapConfiguration: undefined,
      miscEnumerations: undefined,
      brandingInformation: undefined,
      enableDescriptionDisplay: undefined,
      organizationFilterCategory: undefined,
      sourcedIndividualsReloadingUrl: undefined,
      transportFilterCategory: undefined,
      userAccount: undefined,
    };
  },

  computed: {
    activatedEntity() {
      let entity = activateEntityFromList(
          this.optimizedEntities,
          this.activatedEntityIdentifier
      );

      if (entity) {
        // Ensure that URL and localStorage reflect the currently selected entity
        history.replaceState(
            {},
            null,
            this.$route.path + '?entity=' + encodeURIComponent(entity.identifier)
        );
        localStorage.setItem(
            lastActivatedEntityIdentifierStorageKey,
            entity.identifier
        );
      }
      return entity;
    },

    currentClientPk() {
      let activatedEntity = this.activatedEntity;
      if (!activatedEntity) return undefined;

      return activatedEntity.entityObj.client;  // Always present since we have no Client-level entity here
    },

    currentProjectPk() {
      /* Retrieve the DB primary key of the Project linked to the currently activated Observatory entity */
      let activatedEntity = this.activatedEntity;
      if (!activatedEntity) return undefined;

      let currentProjectPk = undefined;
      if (activatedEntity.entityType == "project")
        currentProjectPk = activatedEntity.entityObj.pk;
      else if (activatedEntity.entityType == "organization")
        currentProjectPk = activatedEntity.entityObj.project;

      return currentProjectPk;
    },

    currentOrganizationPk() {
      /* Retrieve the DB primary key of the currently activated Organization, or undefined if we're at Project level */
      let activatedEntity = this.activatedEntity;
      if (!activatedEntity) return undefined;

      let currentOrganizationPk = undefined;
      if (activatedEntity.entityType == "organization")
        currentOrganizationPk = activatedEntity.entityObj.pk;

      return currentOrganizationPk;
    },

    finalFilteredIndividuals: function () {
      if (!this.sourcedIndividuals || !this.mapConfiguration)
          // If set, then by construction all other data fields are ready too!
        return undefined;
      //[LOG] console.log("START FILTERING INDIVIDUALS");

      function _getPksOfIndividualsSelectedBySingleFilter(filterObj, activatedFilterOptionsForFilterObj) {
        if (!activatedFilterOptionsForFilterObj.length) {
          //[LOG] console.log("OPTIMIZZZZZZZZZZZ A");
          return []; // OPTIMIZATION, NO option was enabled, so no individuals could be selected
        }

        if (activatedFilterOptionsForFilterObj.length === filterObj.filterOptions.length) {
          //[LOG] console.log("OPTIMIZZZZZZZZZZZ B");
          return null; // OPTIMIZATION, ALL options were enabled, so we return NULL to say "no filtering must occur"
        }

        let selectedIndividualPks = []
        for (let filterOptionObj of filterObj.filterOptions) {
          if (activatedFilterOptionsForFilterObj.includes(filterOptionObj.slug)) {
            selectedIndividualPks = _.union(selectedIndividualPks, filterOptionObj.baseIndividuals)
          }
        }

        //[LOG] console.log("@@ WE HAVE FOR SINGLE FILTER", filterObj.slug, selectedIndividualPks);
        return selectedIndividualPks;
      }

      function _getPksOfIndividualsSelectedByFilterCategory(filterCategory)  {

        let selectedIndividualPks = null;  // NULL means "no filtering" (yet)

        for (let filterObj of filterCategory.filters) {
          let individualPksToIntersect = _getPksOfIndividualsSelectedBySingleFilter(filterObj, filterCategory.activatedFilterOptions[filterObj.slug])

          if (individualPksToIntersect === null) {
            //[LOG] console.log("OPTIMIZZZZZZZZZZZ C");
            // Do nothing
          } else if (individualPksToIntersect.length === 0) {
            //[LOG] console.log("OPTIMIZZZZZZZZZZZ D");
            selectedIndividualPks = [];
            break;  // Micro-optimization
          } else {
            //[LOG] console.log("@@@ REALLY DOING OPTIONS INTERSECTION FOR FILTER", filterObj.slug, "because", individualPksToIntersect);
            if (selectedIndividualPks === null)
              selectedIndividualPks = individualPksToIntersect;
            else
              selectedIndividualPks = _.intersection(selectedIndividualPks, individualPksToIntersect)
          }

          if (selectedIndividualPks !== null && selectedIndividualPks.length === 0) {
            //[LOG] console.log("OPTIMIZZZZZZZZZZZ BREAK 1");
            break;  // No point in continuing the filtering!
          }

        }

        return selectedIndividualPks;  // Might be NULL still, meaning "no filtering by the category"
      }

      let individualsInitial = this.sourcedIndividuals;

      let individualsFinal;

      let TAKE_OPTIMIZED_PATH = true;
      if (TAKE_OPTIMIZED_PATH) {

        let individualsPksFiltered = individualsInitial.map(
                  (individual) => individual.pk
              );

        for (let filterCategory of [this.organizationFilterCategory, this.individualFilterCategory, this.transportFilterCategory, this.comparisonFilterCategory]) {
          let individualPksForCategory = _getPksOfIndividualsSelectedByFilterCategory(filterCategory);
          if (individualPksForCategory === null) {
            //[LOG] console.log("OPTIMIZZZZZZZZZZZ E");
            // DO NOTHING
          } else if (individualPksForCategory.length === 0) {
            //[LOG] console.log("OPTIMIZZZZZZZZZZZ F");
            individualsPksFiltered = [];
            break;  // Micro-optimization
          } else {
            //[LOG] console.log("@@@ REALLY DOING CATEGORY INTERSECTION because", individualPksForCategory);
            individualsPksFiltered = _.intersection(individualsPksFiltered, individualPksForCategory)
          }
        }

        if (individualsPksFiltered.length == individualsInitial.length) {
          //[LOG] console.log("@@ NO PRECISE FILTERING OF INDIVIDUALS");
          individualsFinal = individualsInitial;  // NO FILTERING AT ALL here
        } else {
          //[LOG] console.log("@@ SOME PRECISE FILTERING OF INDIVIDUALS HAPPENED");
          individualsFinal = individualsInitial.filter(individual => individualsPksFiltered.includes(individual.pk));
        }

      } else {

        // We only consider organizations that were not filtered-out
        let activatedAndFilteredOrganizations =
            this.filterObjectsWithFilterCategoryActivatedFilterOptions(
                this.activatedOrganizations,
                this.organizationFilterCategory
            );
        let activatedOrganizationPks = activatedAndFilteredOrganizations.map(
            (organization) => organization.pk
        );

        // Filter individuals by these filtered organizations
        let individuals1;
        if (activatedOrganizationPks.length == this.allOrganizations.length) {
          individuals1 = individualsInitial;
          //[LOG] console.log(">> SKIPPED FILTERING 1")
        } else {
          individuals1 = this.sourcedIndividuals.filter((individual) =>
              activatedOrganizationPks.includes(individual.organization)
          );
        }

        // Filter individuals by their own filtering category
        //[LOG] console.log("FILTERING INDIVIDUALS VIA THEIR ATTRIBUTES", JSON.stringify(this.individualFilterCategory.activatedFilterOptions))
        let individuals2 =
            this.filterObjectsWithFilterCategoryActivatedFilterOptions(
                individuals1,
                this.individualFilterCategory
            );

        // Filter individuals by calculations about transports
        let individuals3 = this.filterIndividualsWithRouteAssessmentFilter(
            individuals2,
            this.transportFilterCategory.activatedFilterOptions
        );

        // Filter individuals by calculations about comparisons
        individualsFinal = this.filterIndividualsWithRouteAssessmentFilter(
            individuals3,
            this.comparisonFilterCategory.activatedFilterOptions
        );
      }

      //[LOG] console.log("@@ FINAL INDIVIDUALS TO DISPLAY", individualsFinal);
      //[LOG] console.log("STOP FILTERING INDIVIDUALS");
      return individualsFinal;
    },

    importedIndividualWorkforce() {
      if (!this.allOrganizations) return 0; // FIXME: PCH: Add utilities like smartSumByField()
      return this.allOrganizations.reduce((count, obj2) => {
        return count + obj2.imported_workforce;
      }, 0);
    },

    mapColorizerCategories: function () {
      /* A single mapColorizer contains the information on how to colorize the map points for each possible filter option */

      let self = this;

      if (!self.finalFilteredIndividuals) return undefined; // Else, by construction, other data is set too

      function getOrganizationDataSourceMapColorizerColorKey(individual) {
        return individual.organization;
      }

      let activatedOrganizationsClone = structuredClone(
          self.activatedOrganizations
      );

      // Here we add individualCount values on a activatedOrganizations clone (modifying self.activatedOrganizations would create an update loop alas)
      for (let organization of activatedOrganizationsClone) {
        let individuals = self.finalFilteredIndividuals.filter(
            (individual) => individual.organization == organization.pk
        );
        self.$set(organization, "individualCount", individuals.length); // Detects nested mutations
      }

      let organizationDataSourceMapColorizer = {
        colorKey: getOrganizationDataSourceMapColorizerColorKey,
        colorMapper: Object.fromEntries(
            activatedOrganizationsClone.map((organization) => [
              organization.pk,
              organization.color,
            ])
        ),
        criteria: activatedOrganizationsClone,
        criteriaSlug: "pk",
        identifier: "organization-identity", // DO NOT CHANGE VALUE, used elsewhere!
        label: "Sites",
      };

      function getMapColorizers(groupSlug, filterCategory, colorKey) {
        let mapColorizers = [];

        for (let filter of filterCategory.filters) {
          let optionMapColorizerColorKey = colorKey.bind(null, filter.slug);
          let activatedFilterOptionSlugs =
              filterCategory.activatedFilterOptions[filter.slug];
          let filteredActivatedFilterOptionSlugs = filter.filterOptions.filter(
              (filterOption) =>
                  activatedFilterOptionSlugs.includes(filterOption.slug)
          );

          mapColorizers.push({
            colorKey: optionMapColorizerColorKey,
            colorMapper: Object.fromEntries(
                filteredActivatedFilterOptionSlugs.map((filterOption) => [
                  filterOption.slug,
                  filterOption.color,
                ])
            ),
            criteria: filteredActivatedFilterOptionSlugs,
            criteriaSlug: "slug",
            identifier: `${groupSlug}-${filter.slug}`, // Thus unique enough
            label: filter.label,
          });
        }

        return mapColorizers;
      }

      function getOrganizationFilterMapColorizerColorKey(
          filterSlug,
          individual
      ) {
        let organization = self.lookUpOrganizationOfIndividual(individual);

        return (
            organization.attribute_tree[filterSlug] ||
            self.gmbConstants.noFilterOptionSlug
        );
      }

      let organizationFilterMapColorizers = getMapColorizers(
          "organization_filters",
          self.organizationFilterCategory,
          getOrganizationFilterMapColorizerColorKey
      );

      function getIindividualFilterMapColorizerColorKey(  // FIXME TYPO
          filterSlug,
          individual
      ) {
        return (
            individual.attribute_tree[filterSlug] ||
            self.gmbConstants.noFilterOptionSlug
        );
      }

      let individualFilterMapColorizers = getMapColorizers(
          "individual_filters",
          self.individualFilterCategory,
          getIindividualFilterMapColorizerColorKey
      );

      function getCalculationFilterMapColorizerColorKey(
          filterSlug,
          individual
      ) {
        let currentRouteAssessment =
            self.findCurrentRouteAssessmentForIndividual(individual);
        return (
            currentRouteAssessment[filterSlug] ||
            self.gmbConstants.noFilterOptionSlug
        );
      }

      let transportFilterMapColorizers = [];
      let comparisonFilterMapColorizers = [];
      let filterMapColorizers = [
        [self.transportFilterCategory, transportFilterMapColorizers],
        [self.comparisonFilterCategory, comparisonFilterMapColorizers],
      ];

      for (let [filterCategory, mapColorizers] of filterMapColorizers) {
        for (let filter of filterCategory.filters) {
          let activatedFilterOptionSlugs =
              filterCategory.activatedFilterOptions[filter.slug];
          let filteredActivatedFilterOptionSlugs = filter.filterOptions.filter(
              (filterOption) =>
                  activatedFilterOptionSlugs.includes(filterOption.slug)
          );
          let mapColorizerColorKey =
              getCalculationFilterMapColorizerColorKey.bind(null, filter.slug);

          mapColorizers.push({
            colorKey: mapColorizerColorKey,
            colorMapper: Object.fromEntries(
                filteredActivatedFilterOptionSlugs.map((filterOption) => {
                  return [filterOption.slug, filterOption.color];
                })
            ),
            criteria: filteredActivatedFilterOptionSlugs,
            criteriaSlug: "slug",
            identifier: `route_assessment-${filter.slug}`, // Thus unique enough
            label: filter.label,
          });
        }
      }

      // mapColorizerCategories is an array of mapColorizerCategory objects containing mapColorizers
      return [
        {
          mapColorizers: [organizationDataSourceMapColorizer],
          label: "Sites",
        },
        {
          mapColorizers: organizationFilterMapColorizers,
          label: "Profil des sites",
        },
        {
          mapColorizers: individualFilterMapColorizers,
          label: "Profil des individus",
        },
        {
          mapColorizers: transportFilterMapColorizers,
          label: "Accessibilité",
        },
        {
          mapColorizers: comparisonFilterMapColorizers,
          label: "Comparaisons",
        },
      ];
    },

    optimizedEntities() {  // FIXME this is NOT at ALL an optimization!
      /* We have to remove CLIENTS, which are too high-level to have all their Individuals displayed! */
      if (!this.allEntities) return undefined;
      return this.allEntities.filter((entity) => entity.entityType != "client");
    },

    activatedOrganizations: function () {
      if (!this.allOrganizations) return undefined;
      return this.allOrganizations.filter((obj) => obj.isActivated);
    },

    sourcedIndividuals: function () {
      /* mapConfiguration is used as a marker for all other data fields */
      if (!this.allIndividuals || !this.activatedOrganizations)
        return undefined;

      let dataSourceOrganizationPks = this.activatedOrganizations.map(
          (organization) => organization.pk
      );

      let sourcedIndividuals = this.allIndividuals.filter((individual) =>
          dataSourceOrganizationPks.includes(individual.organization)
      );

      for (let individual of sourcedIndividuals)
        individual.cachedCurrentRouteAssessement =
            this.findCurrentRouteAssessmentForIndividual(individual);

      return sourcedIndividuals;
    },

    sourcedIndividualWorkforce() {
      if (!this.activatedOrganizations) return 0;

      return this.activatedOrganizations.reduce((obj1, obj2) => {
        return obj1 + obj2.imported_workforce;
      }, 0);
    },

    theoreticalIndividualWorkforce() {
      if (!this.allOrganizations) return 0;

      return this.allOrganizations.reduce((obj1, obj2) => {
        return obj1 + obj2.theoretical_workforce;
      }, 0);
    },

    transportFiltersForIndividualMapPointInfo() {
      return this.transportFilterCategory
          ? this.transportFilterCategory.filters
          : [];
    },

    userCanAccessDataEdition() {
      if (!this.userAccount) return false;
      if (this.userAccount.is_superuser) return true;
      if (!this.userAccount.has_frontoffice_access) return false;
      let pricingPlan = this.userAccount.pricing_plan;
      return pricingPlan == "GOLD";
    },

    userCanAccessStatistics() {
      if (!this.userAccount) return false;
      let pricingPlan = this.userAccount.pricing_plan;
      return pricingPlan == "GOLD" || pricingPlan == "SILVER";  // Superusers are always GOLD
    },

    userCanAccessPdfExporter() {
      if (!this.userAccount) return false;
      if (this.userAccount.is_superuser) return true;
      if (!this.userAccount.has_pdf_exporter_access) return false;
      let pricingPlan = this.userAccount.pricing_plan;
      return pricingPlan == "GOLD" || pricingPlan == "SILVER";
    },
  },

  watch: {
    activatedEntity: {
      handler: function (newActivatedEntity) {
        if (!newActivatedEntity) return undefined;
        if (newActivatedEntity.entityType == "project")
          this.loadProjectData(newActivatedEntity.entityObj.pk);
        else if (newActivatedEntity.entityType == "organization")
            // We restrict project to THIS organization!
          this.loadProjectData(
              newActivatedEntity.entityObj.project,
              newActivatedEntity.entityObj.pk
          );
      },
      immediate: true,
    },

    allIndividuals() {
      this.setBaseIndividualCountsInAllOrganizations();
    }, // not IMMEDIATE

    allOrganizations() {
      this.setBaseIndividualCountsInAllOrganizations();
    }, // not IMMEDIATE

    // FIXME: MINOR BUG: sourcedIndividuals NEEDS to be placed BEFORE finalFilteredIndividuals
    sourcedIndividuals: {
      handler: function () {
        this.setBaseIndividualCountsInAllFilters();
      },
      immediate: true,
    },

    // FIXME: MINOR BUG: finalFilteredIndividuals NEEDS to be placed AFTER sourcedIndividuals
    finalFilteredIndividuals: {
      handler: function () {
        if (!this.finalFilteredIndividuals) return;

        let finalFilteredIndividualsPks = this.finalFilteredIndividuals.map(
            (individual) => individual.pk
        );

        this.setFilteredIndividualCountsInCategoryFilters(
            finalFilteredIndividualsPks
        );
      },
      immediate: true,
    },

    isAuthenticated: {
      handler: function (newIsAuthenticated) {
        if (!newIsAuthenticated) return;
        this.loadAllEntities(); // Now that we are logged, we can load all entities
      },
      immediate: true,
    },
  },

  beforeCreate() {
  },

  async created() {
    const isAuthenticated = await authentication.isAuthenticated();

    if (isAuthenticated) {
      this.isAuthenticated = true; // Triggers loading of all entities
      try {
        const accountResponse = await authentication.getAccountQuery();
        this.userAccount = accountResponse.data;
      } catch (err) {
        throw err;
      }
    } else router.push("/authentication/");
  },

  beforeMount() {
  },

  mounted() {
    //console.log(">>>>>>>>>>>entitySlug", this.activatedEntityIdentifierFromUrl, " and activatedEntityIdentifier", this.activatedEntityIdentifier);
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {

    onSwitchSidePanelVisibility(forcedValue) {
      //console.log("observatory onSwitchSidePanelVisibility called", this.isSidePanelOpen);
      this.isSidePanelOpen = (forcedValue !== undefined) ? forcedValue : !this.isSidePanelOpen;
      this.requestMapSizeUpdate();
    },

    setBaseIndividualCountsInAllOrganizations() {
      if (!this.allOrganizations || !this.allIndividuals) return;

      // Add to each organization the count of its listed individuals (for safety we don't just trust the server on that)

      // FIXME LATER we can optimize that, with only 1 loop over allIndividuals, but it's not a big gain
      for (let organization of this.allOrganizations) {
        let individuals = this.allIndividuals.filter(
            (individual) => individual.organization == organization.pk
        );

        this.$set(organization, "baseIndividualCount", individuals.length); // Detects nested mutations
      }
    },

    setBaseIndividualCountsInAllFilters() {
      /* Set counts of individuals concerned by each filter option,
      BEFORE real filtering happened */

      let self = this;

      if (!self.sourcedIndividuals || !self.mapConfiguration) {
        // mapConfiguration represents the presence of ALL FILTERS too
        return;
      }

      const individualPkListField = "baseIndividuals";
      const individualPkCountField = "baseIndividualCount";

      function setBaseIndividualCountsInFilter(
          filterCategoryFilters,
          entityList,
          annotationCallback
      ) {
        for (let filter of filterCategoryFilters)
          for (let filterOption of filter.filterOptions) {
            let matchingEntities = entityList.filter(
                (entity) =>
                    (entity.attribute_tree[filter.slug] ||
                        self.gmbConstants.noFilterOptionSlug) == filterOption.slug
            );

            annotationCallback(filterOption, matchingEntities);
          }
      }

      // Add to each individual-filter filter option the count of matching individuals (from ACTIVATED organizations)
      function individualFilterAnnotationCallback(optionObject, individuals) {

        self.$set(
            optionObject,
            individualPkListField,
            individuals.map((obj) => obj.pk)
        );

        self.$set(optionObject, individualPkCountField, individuals.length);
      }

      setBaseIndividualCountsInFilter(
          self.individualFilterCategory.filters,
          self.sourcedIndividuals,
          individualFilterAnnotationCallback
      );

      // Add to each organization-filter filter option the count of matching individuals (from ACTIVATED organizations)
      function organizationFilterAnnotationCallback(
          optionObject,
          matchingOrganizations
      ) {
        let matchingOrganizationsPks = matchingOrganizations.map(
            (organization) => organization.pk
        );

        let individuals = self.sourcedIndividuals.filter((individual) =>
            matchingOrganizationsPks.includes(individual.organization)
        );

        self.$set(
            optionObject,
            individualPkListField,
            individuals.map((obj) => obj.pk)
        );

        self.$set(optionObject, individualPkCountField, individuals.length);
      }

      setBaseIndividualCountsInFilter(
          self.organizationFilterCategory.filters,
          self.activatedOrganizations, // We only consider ACTIVATED organizations here!
          organizationFilterAnnotationCallback
      );

      // Add to each route assessment filter option the count of matching individuals (from ACTIVATED organizations)
      for (let routeAssessmentFilterCategory of [
        self.transportFilterCategory.filters,
        self.comparisonFilterCategory.filters,
      ]) {
        for (let filter of routeAssessmentFilterCategory)
          for (let filterOption of filter.filterOptions) {
            let individuals = self.sourcedIndividuals.filter((individual) => {
              let route_assessment =
                  self.findCurrentRouteAssessmentForIndividual(individual);

              return (
                  (route_assessment[filter.slug] ||
                      self.gmbConstants.noFilterOptionSlug) == filterOption.slug
              );
            });

            self.$set(
                filterOption,
                individualPkListField,
                individuals.map((obj) => obj.pk)
            );

            self.$set(filterOption, individualPkCountField, individuals.length);
          }
      }
    },

    setFilteredIndividualCountsInCategoryFilters(displayedIndividualPks) {
      let self = this;

      //[LOG] console.log("START SETTING INDIVIDUAL COUNTS IN FILTERS");

      function _setFilteredIndividualCountsInCategoryFilters(filterCategory) {
        let filterCategoryActivatedFilterOptions =
            filterCategory.activatedFilterOptions;

        for (let filter of filterCategory.filters) {
          for (let filterOption of filter.filterOptions) {
            if (
                !filterCategoryActivatedFilterOptions[filter.slug].includes(
                    filterOption.slug
                )
            )
              self.$set(filterOption, "individualCount", 0); // OPTIMIZATION
            else {
              let matchingIndividualPkList = _.intersection(
                  displayedIndividualPks,
                  filterOption.baseIndividuals
              );
              self.$set(
                  filterOption,
                  "individualCount",
                  matchingIndividualPkList.length
              );
            }
          }
        }
      }

      _setFilteredIndividualCountsInCategoryFilters(
          this.comparisonFilterCategory
      );

      _setFilteredIndividualCountsInCategoryFilters(
          this.individualFilterCategory
      );

      _setFilteredIndividualCountsInCategoryFilters(
          this.organizationFilterCategory
      );

      _setFilteredIndividualCountsInCategoryFilters(
          this.transportFilterCategory
      );

      //[LOG] console.log("STOP SETTING INDIVIDUAL COUNTS IN FILTERS");
    },

    findCurrentRouteAssessmentForIndividual(individual) {
      let organization = this.lookUpOrganizationOfIndividual(individual);

      if (organization.selectedAddressIndex != undefined) {
        // Else no addresses for this organization

        let organizationLocationPk =
            organization.addressList[organization.selectedAddressIndex].pk; // MUST exist

        let routeAssessment = individual.route_assessments.find(
            (route_assessment) =>
                route_assessment.organization_location == organizationLocationPk
        );
        if (routeAssessment)
            // Else, no route assessment record created for this location yet, e.g. user just got imported to DB
          return routeAssessment;
      }

      return {}; // EMPTY by default, so will fallback to gmbConstants.noFilterOptionSlug
    },

    filterIndividualsWithRouteAssessmentFilter(
        individuals,
        selectedCalculationValues
    ) {
      return individuals.filter((individual) => {
        let routeAssessment =
            this.findCurrentRouteAssessmentForIndividual(individual);

        for (const [calculation, filterOptions] of Object.entries(
            selectedCalculationValues
        )) {
          const routeAssessmentFieldValue =
              routeAssessment[calculation] ||
              this.gmbConstants.noFilterOptionSlug;
          if (!filterOptions.includes(routeAssessmentFieldValue)) return false;
        }

        return true;
      });
    },

    filterObjectsWithFilterCategoryActivatedFilterOptions(
        objects,
        filterCategory
    ) {

      let filterCategoryActivatedFilterOptions = filterCategory.activatedFilterOptions;

      for (let filter of filterCategory.filters) {

      }

      // We can received organizations or individuals here, in 'objects'
      return objects.filter((object) => {
        for (const [filter, filterOptions] of Object.entries(
            filterCategoryActivatedFilterOptions
        )) {
          const objectFilterOption =
              object.attribute_tree[filter] ||
              this.gmbConstants.noFilterOptionSlug;
          if (!filterOptions.includes(objectFilterOption)) return false;
        }

        return true;
      });
    },

    goToIndividualsEditPage(individualPks) {
      this.$refs.tabs.activateTab(2); // Switch to DataEdition

      /* Wait for next tick so that the lazy tab has loaded! */
      this.$nextTick(() => {
        this.$refs.DataEdition.switchToIndividuals(individualPks);
      });
    },

    loadAllEntities() {
      this.enableSpinner();
      Promise.all([
        getApiEndpoint("api/clients/?credentials=1"),
        getApiEndpoint("api/projects/?credentials=1"),
        getApiEndpoint("api/organizations/?credentials=1"),
      ]).then((values) => {
        let [clients, projects, organizations] = [
          values[0].data,
          values[1].data,
          values[2].data,
        ];
        let allEntities = [];

        function getProjectLabelAndClientPk(projectPk) {
          let project = projects.find((obj) => obj.pk == projectPk);
          return project ? [project.label, project.client] : ["", null];
        }

        function getClientLabel(clientPk) {
          let client = clients.find((obj) => obj.pk == clientPk);
          return client ? client.label : "";
        }

        for (let client of clients) {
          allEntities.push({
            client: client.label,
            entityObj: client,
            entityType: "client",
            organization: "",
            project: "",
          });
        }

        for (let project of projects) {
          let clientLabel = getClientLabel(project.client);
          allEntities.push({
            client: clientLabel,
            entityObj: project,
            entityType: "project",
            organization: "",
            project: project.label,
          });
        }

        for (let organization of organizations) {
          let [projectLabel, clientPk] = getProjectLabelAndClientPk(
              organization.project
          );
          let clientLabel = clientPk ? getClientLabel(clientPk) : "";

          allEntities.push({
            client: clientLabel,
            entityObj: organization,
            entityType: "organization",
            organization: organization.label,
            project: projectLabel,
          });
        }

        for (let [i, entity] of allEntities.entries()) {
          // BEWARE keep this formula untouched, since its gets stored in localStorage and linked from backoffice!
          entity.identifier = entity.entityType + "-" + entity.entityObj.pk; // Store some unique identifier for recognition
        }
        this.allEntities = allEntities;
      }).finally(this.disableSpinner);  // In any case!
    },

    loadProjectData(projectPk, restrictToOrganizationPk) {

      this.enableSpinner(); // For project configuration loading only here!

      // BIG RESET OF PROJECT DATA //
      this.allIndividuals = undefined;
      this.allOrganizations = undefined;
      this.comparisonFilterCategory = undefined;
      this.individualFilterCategory = undefined;
      this.sourcedIndividualsReloadingUrl = undefined;
      this.mapConfiguration = undefined;
      this.miscEnumerations = undefined;
      this.brandingInformation = undefined;
      this.enableDescriptionDisplay = undefined;
      this.organizationFilterCategory = undefined;
      this.transportFilterCategory = undefined;

      getApiEndpoint(`api/projects/${projectPk}/configuration/`).then((res) => {
        let allProjectData = res.data;

        this.comparisonFilterCategory = this.parseIndividualFilterCategory(
            allProjectData.routeAssessmentFiltersAboutComparisons
        );
        this.individualFilterCategory = this.parseIndividualFilterCategory(
            allProjectData.attributeFiltersForIndividuals
        );
        this.mapConfiguration = allProjectData.mapConfiguration;
        this.miscEnumerations = allProjectData.miscEnumerations;
        this.brandingInformation = allProjectData.brandingInformation;
        this.enableDescriptionDisplay = allProjectData.enableDescriptionDisplay;
        this.organizationFilterCategory = this.parseIndividualFilterCategory(
            allProjectData.attributeFiltersForOrganizations
        );
        this.transportFilterCategory = this.parseIndividualFilterCategory(
            allProjectData.routeAssessmentFiltersAboutTransports
        );
        this.setBaseIndividualCountsInAllFilters();
      }).finally(this.disableSpinner);

      let _individualLoadingBase = "api/individuals/?cache=1";
      let sourcedIndividualsReloadingUrl = `${_individualLoadingBase}&project=${projectPk}`;
      if (restrictToOrganizationPk)
          // User account maybe doesn't have access to project object!
        sourcedIndividualsReloadingUrl = `${_individualLoadingBase}&organization=${restrictToOrganizationPk}`;

      this.sourcedIndividualsReloadingUrl = sourcedIndividualsReloadingUrl;
      this.reloadProjectIndividuals(); // NOW we force a loading of individuals

      // FIXME LATER we could find these organisations in loaded "all entities", to optimize
      if (restrictToOrganizationPk != undefined)
        getApiEndpoint(`api/organizations/${restrictToOrganizationPk}/`).then(
            (res) => {
              this.allOrganizations = this.parseOrganizations([res.data]);
            }
        );
      else
        getApiEndpoint(`api/organizations/?project=${projectPk}`).then(
            (res) => {
              this.allOrganizations = this.parseOrganizations(res.data);
            }
        );
    },

    lookUpOrganizationOfIndividual(individual) {
      return this.activatedOrganizations.find(
          (organization) => organization.pk == individual.organization
      ); // MUST exist, since individual is ACTIVE
    },

    onComparisonFilterActivatedOptionsChanged(
        filterSlug,
        newActivatedFilterOptionSlugs
    ) {
      this.comparisonFilterCategory.activatedFilterOptions[filterSlug] =
          newActivatedFilterOptionSlugs;
    },

    onActivatedEntityChanged(newActivatedEntitySlug) {
      this.activatedEntityIdentifier = newActivatedEntitySlug;
    },

    onIndividualFilterActivatedOptionsChanged(
        filterSlug,
        newActivatedFilterOptionSlugs
    ) {
      this.individualFilterCategory.activatedFilterOptions[filterSlug] =
          newActivatedFilterOptionSlugs;
    },

    onOrganizationDataSourcesActivatedOrganizationsChanged(organizationSlugs) {
      let allOrganizationsClone = this.allOrganizations;

      allOrganizationsClone.forEach((organization) => {
        organization.isActivated = organizationSlugs.includes(
            organization.slug
        );
      });

      this.allOrganizations = allOrganizationsClone;
    },

    onOrganizationDataSourcesActivatedAddressChanged(
        organizationSlug,
        addressSlug
    ) {
      let organization = findObjectInArrayByPropertyValue(
          this.allOrganizations,
          "slug",
          organizationSlug
      ); // MUST exist
      let addressIndex = findObjectIndexInArrayByPropertyValue(
          organization.addressList,
          "slug",
          addressSlug
      ); // MUST exist

      organization.selectedAddressIndex = addressIndex;
    },

    onOrganizationFilterActivatedOptionsChanged(
        filterSlug,
        newActivatedFilterOptionSlugs
    ) {
      this.organizationFilterCategory.activatedFilterOptions[filterSlug] =
          newActivatedFilterOptionSlugs;
    },

    onTransportFilterActivatedOptionsChanged(filterSlug, calculationOptions) {
      this.transportFilterCategory.activatedFilterOptions[filterSlug] =
          calculationOptions;
    },

    onIndividualsEdited(individualPks) {
      individualPks.length == 1
          ? this.refreshSingleIndividual(individualPks[0])
          : this.reloadProjectIndividuals(); // Let's not complexify stuffs too much...

      // No need for this.setBaseIndividualCountsInAllFilters(), will be called via sourcedIndividuals watcher!
    },

    onExportStatisticsToReporting(statisticsChapterData) {
      let fullStatsExportData = Object.assign({}, statisticsChapterData,);
      fullStatsExportData.reporting_context_summary = this.getReportingContextSummary();
      //console.log(">>> fullStatsExportData", fullStatsExportData);
      this.$refs.Reporting.appendReportingSection(
          "statistics", fullStatsExportData
      )
    },

    onExportMapToReporting(mapChapterData) {
      let fullMapExportData = Object.assign({}, mapChapterData,);
      fullMapExportData.reporting_context_summary = this.getReportingContextSummary();
      //console.log(">>> fullMapExportData", fullMapExportData);
      this.$refs.Reporting.appendReportingSection(
          "map", fullMapExportData
      )
    },

    getReportingContextSummary() {  // TEMP COMPUTED
      function extractSelectedFilterOptionLabels(filterTree) {

        let activatedFilterOptions = filterTree.activatedFilterOptions;  // Maps filter slug to list of option slugs

        let allSelectedFilterOptionLabels = [];

        for (let filter of filterTree.filters) {

          let selectedFilterOptionSummary = null;  // will be a triplet (label, selected_options, deselected_options)

          let selectedOptionsForFilter = activatedFilterOptions[filter.slug];

          if (selectedOptionsForFilter.length == 0) {
            selectedFilterOptionSummary = ["NONE", [], []];
          } else if (selectedOptionsForFilter.length == filter.filterOptions.length) {
            selectedFilterOptionSummary = ["ALL", [], []];
          } else {
            let selectedOptions = [];
            let deselectedOptions = [];
            for (let filterOption of filter.filterOptions) {
              if (selectedOptionsForFilter.includes(filterOption.slug)) {
                selectedOptions.push(filterOption.label);
              } else {
                deselectedOptions.push(filterOption.label);
              }
            }
            selectedFilterOptionSummary = [selectedOptions.length + "/" + filter.filterOptions.length, selectedOptions, deselectedOptions];
          }

          allSelectedFilterOptionLabels.push([filter.label, selectedFilterOptionSummary]);
        }

        return allSelectedFilterOptionLabels;
      }

      return {
        entity: {
          type: this.activatedEntity.entityType,
          label: this.activatedEntity.entityObj.label,
          description: this.activatedEntity.entityObj.description,
        },
        source_organizations: this.activatedOrganizations.map(
            organization => {
              return {
                label: organization.label,
                address_parts: (organization.selectedAddressIndex != undefined ? organization.addressList[organization.selectedAddressIndex] : null),
                imported_workforce: organization.imported_workforce,
                theoretical_workforce: organization.theoretical_workforce,
              };
            }
        ),
        filters_on_organization_attributes: extractSelectedFilterOptionLabels(this.organizationFilterCategory),
        filters_on_individual_attributes: extractSelectedFilterOptionLabels(this.individualFilterCategory),
        filters_on_transports: extractSelectedFilterOptionLabels(this.transportFilterCategory),
        filters_on_comparisons: extractSelectedFilterOptionLabels(this.comparisonFilterCategory),
      }

    },

    parseIndividualFilterCategory(filterCategory) {
      //[LOG] console.log("CALLED parseIndividualFilterCategory", filterCategory);
      /* Useful both for TRANSPORT and COMPARISON filter trees! */
      let activatedFilterOptions = {};
      for (let filter of filterCategory) {
        activatedFilterOptions[filter.slug] = [];

        // Special option "no value" for filter
        filter.filterOptions.push({
          color: this.gmbConstants.noFilterOptionColor,
          label: this.gmbConstants.noFilterOptionLabel,
          pk: null, // Important for DataEdition system
          slug: this.gmbConstants.noFilterOptionSlug,
        });

        for (let filterOption of filter.filterOptions)
          activatedFilterOptions[filter.slug].push(filterOption.slug);
      }

      return {
        activatedFilterOptions: activatedFilterOptions,
        filters: filterCategory, // Modified in-place
      };
    },

    parseOrganizations(organizations) {
      /* Parse API result to comply with app data model */
      return organizations.map((organization) => {
        return {
          addressList: organization.organization_locations.map((obj) => {
            obj.label = formatFrenchAddress(obj.address, obj.postcode, obj.city);
            obj.slug = "address-" + obj.pk;
            return obj; // Modified in-place, it's OK here
          }),
          attribute_tree: organization.attribute_tree, // Imitate the naming of Individual.attribute_tree
          color: organization.color,
          imported_workforce: organization.imported_workforce,
          isActivated: true, // By default all organizations are used as data sources!
          label: organization.label,
          pk: organization.pk,
          selectedAddressIndex: organization.organization_locations.length ? 0 : undefined, // The first address is the "current" one
          slug: organization.slug,
          theoretical_workforce: organization.theoretical_workforce,
        };
      });
    },

    refreshSingleIndividual(individualPk) {
      getApiEndpoint(`api/individuals/${individualPk}/`).then((res) => {
        let individualIndex = this.allIndividuals.findIndex(
            (individual) => individual.pk == individualPk
        );
        this.allIndividuals.splice(individualIndex, 1, res.data);
      });
    },

    reloadProjectIndividuals() {
      this.enableSpinner();
      let sourcedIndividualsReloadingUrl = this.sourcedIndividualsReloadingUrl; // MUST exist by construction
      getApiEndpoint(sourcedIndividualsReloadingUrl).then((res) => {
        this.allIndividuals = res.data;
        /* HACK TO INCREASE NUMBER OF INDIVIDUALS
        this.allIndividuals = res.data.concat(
            _.cloneDeep(res.data), _.cloneDeep(res.data), _.cloneDeep(res.data), _.cloneDeep(res.data), _.cloneDeep(res.data),
            _.cloneDeep(res.data), _.cloneDeep(res.data), _.cloneDeep(res.data), _.cloneDeep(res.data), _.cloneDeep(res.data)
        );
        for (let i=0; i<this.allIndividuals.length ; i++) {
          this.allIndividuals[i].pk = 1000000000 + i;
          this.allIndividuals[i].latitude += random(0.00001, 0.00002);
          this.allIndividuals[i].longitude += random(0.00001, 0.00002);
        }*/
        //[LOG] console.log("INDIVIDUALS LOADED", this.allIndividuals.map(x => x.pk))
      }).finally(this.disableSpinner);
    },

    processLogout() {
      authentication.logout();
    },

    onActivatedTabChanged(tabIndex) {
      this.onSwitchSidePanelVisibility(true);  // Reset sidebar to "open" mode
      if (tabIndex == 0) {
        this.requestMapSizeUpdate();
      }
    },

    requestMapSizeUpdate() {
      this.$refs.gmbMap.$refs.gmbMapCanvas.fixMapSizingBug();
    },

    enableSpinner() {
      this.spinnerEnabledCounter += 1;
    },
    disableSpinner() {
      this.spinnerEnabledCounter -= 1;
    }
  },
};
</script>

<style lang="scss">

.v-spinner {
  position: absolute !important;
  left: 50%;
  margin-left: -50px;
  top: 50%;
  margin-top: -15px;
  z-index: 9999999999;
  /*overflow: hidden;*/
}

.gmb-horizontally-collapsed {
  // For a different strategy, use: "width: 10px !important: overflow: hidden !important;"
  display: none !important;
}

</style>
